// // import React, { useEffect, useState } from 'react';
// // import { MdOutlineLocationOn } from "react-icons/md";
// // import { apiGET, apiPUT } from '../../utilities/apiHelpers';
// // import { useSelector } from 'react-redux';
// // import Popup from '../Address/Popup';
// // import { toast } from 'react-toastify';
// // import AttachedPrescription from '../presecription/AttachedPrescription';
// // import scrollToTop from '../../utilities/scrollToTop';
// // import { API_URL } from '../../config';
// // import ButtonWithLoader from '../Button/ButtonWithLoader';

// // const AddressStep = ({ stepperProgressCartData, setStepperProgressCartData }) => {
// //     const [isOpen, setIsOpen] = useState(false);
// //     const [selectedAddress, setSelectedAddress] = useState(null);
// //     const userId = useSelector((state) => state.user?.userData?.id) || "";
// //     const [addresses, setAddress] = useState([]);
// //     const [loading, setLoading] = useState(false)

// //     const getUserAddresses = async () => {
// //         const response = await apiGET(`/v1/address/getAddress/${userId}`)
// //         if (response.status) {
// //             console.log(response.data?.data);
// //             setAddress(response.data?.data)
// //         } else {
// //             console.error("Failed to fetch cart data", response);
// //         }
// //     }
// //     const handleSelect = async (address) => {
// //         console.log("Selected Address:", address);
// //         setSelectedAddress(address);
// //     }

// //     const setSelectedAddressFunc = async () => {
// //         if (selectedAddress) {
// //             setLoading(true)
// //             const updateStepperProgressPayload = {
// //                 selectedAddress: selectedAddress,
// //                 currentStep: 3
// //             }
// //             try {
// //                 const userStepperAddResponse = await apiPUT(`${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`, updateStepperProgressPayload);
// //                 console.log("userStepperAddResponse", userStepperAddResponse);
// //                 if (userStepperAddResponse.status) {
// //                     const stepperResponse = await apiGET(`${API_URL}/v1/stepper-progress/user-stepper-progress/${userId}`)
// //                     setStepperProgressCartData(stepperResponse.data?.data);
// //                     setLoading(false)
// //                 }
// //             } catch (error) {
// //                 console.log("Error updating seleted prescription", error);
// //                 setLoading(false)
// //             }
// //         } else {
// //             toast.error("Please select address")
// //             setLoading(false)
// //         }
// //     }

// //     useEffect(() => {
// //         scrollToTop()
// //         if (isOpen === false) {
// //             getUserAddresses()
// //         }
// //     }, [isOpen])

// //     return (
// //         <div className="flex flex-col lg:flex-row justify-between my-5 rounded-lg mx-auto p-5 shadow-lg bg-[#FFFFFF]">
// //             <div className="flex-1 mb-6 lg:mb-0 lg:mr-5">
// //                 <h2 className="text-xl font-semibold mb-2">Address Details</h2>
// //                 <p className="mb-4">Select from saved address</p>
// //                 <div className='max-h-[500px] overflow-y-auto scrollbar-custom scroll-smooth p-2'>
// //                     {addresses?.map((address) => (
// //                         <div key={address._id} className={`flex items-center bg-[#F8F8F8] p-4 mb-4 rounded-lg shadow-md cursor-pointer ${selectedAddress?._id === address._id ? 'border-2 border-blue-500 ' : ''
// //                             }`}
// //                             onClick={() => handleSelect(address)}>
// //                             <div className="text-2xl mr-3"><MdOutlineLocationOn /></div>
// //                             <div>
// //                                 <p className="font-bold">{address.zip}</p>
// //                                 <p>{address.addressLine1}</p>
// //                                 <p>{address.addressLine2}</p>
// //                             </div>
// //                         </div>
// //                     ))}
// //                 </div>
// //                 <div className='flex gap-2'>
// //                     <button onClick={() => setIsOpen(!isOpen)} className="mt-4 py-2 sm:px-4 px-2 bg-[#F1F9FF] text-[#14967F] text-sm sm:text-base rounded-[30px]">
// //                         + Add New Address
// //                     </button>
// //                     <ButtonWithLoader loading={loading} buttonText={"Submit"} onClick={setSelectedAddressFunc} width={"w-[100px]"} />

// //                     {/* <button onClick={setSelectedAddressFunc} className="mt-6 py-2 px-6 bg-[#14967F] text-white rounded-[30px] self-center lg:self-start">
// //                     Submit
// //                 </button> */}
// //                 </div>
// //             </div>
// //             <div className='lg:w-2/5 lg:border-l-2'>
// //                 <AttachedPrescription type="cart" stepperProgressCartData={stepperProgressCartData} />
// //             </div>
// //             {isOpen && <Popup isOpen={isOpen} setIsOpen={setIsOpen} />}
// //         </div>
// //     );
// // };

// // export default AddressStep;

// import React, { useEffect, useState, useCallback } from 'react';
// import { MdOutlineLocationOn } from "react-icons/md";
// import { apiGET, apiPUT } from '../../utilities/apiHelpers';
// import { useSelector } from 'react-redux';
// import Popup from '../Address/Popup';
// import { toast } from 'react-toastify';
// import AttachedPrescription from '../presecription/AttachedPrescription';
// import scrollToTop from '../../utilities/scrollToTop';
// import { API_URL } from '../../config';
// import ButtonWithLoader from '../Button/ButtonWithLoader';

// const AddressStep = ({ stepperProgressCartData, setStepperProgressCartData }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedAddress, setSelectedAddress] = useState(null);
//     const userId = useSelector((state) => state.user?.userData?.id) || "";
//     const [addresses, setAddresses] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [loadingAddresses, setLoadingAddresses] = useState(false);

//     // Fetch user addresses
//     const getUserAddresses = useCallback(async () => {
//         try {
//             setLoadingAddresses(true);
//             const response = await apiGET(`/v1/address/getAddress/${userId}`);
//             if (response.status) {
//                 setAddresses(response.data?.data || []);
//             } else {
//                 setAddresses([]);
//                 console.error("Failed to fetch addresses", response);
//             }
//         } catch (error) {
//             setAddresses([]);
//             console.error("Error fetching addresses:", error);
//         } finally {
//             setLoadingAddresses(false);
//         }
//     }, [userId]);

//     // Handle selecting an address
//     const handleSelect = (address) => {
//         setSelectedAddress(address);
//     };

//     // Submit selected address
//     const setSelectedAddressFunc = async () => {
//         if (!selectedAddress) {
//             toast.error("Please select address");
//             return;
//         }

//         setLoading(true);
//         const payload = {
//             selectedAddress,
//             currentStep: 3
//         };

//         try {
//             const userStepperAddResponse = await apiPUT(`${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`, payload);
//             if (userStepperAddResponse.status) {
//                 const stepperResponse = await apiGET(`${API_URL}/v1/stepper-progress/user-stepper-progress/${userId}`);
//                 setStepperProgressCartData(stepperResponse.data?.data);
//                 toast.success("Address selected successfully");
//             } else {
//                 toast.error("Failed to update stepper progress");
//             }
//         } catch (error) {
//             console.error("Error updating selected address:", error);
//             toast.error("Error updating address");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Load addresses when component mounts or popup closes
//     useEffect(() => {
//         scrollToTop();
//         if (!isOpen) {
//             getUserAddresses();
//         }
//     }, [isOpen, getUserAddresses]);

//     return (
//         <div className="flex flex-col lg:flex-row justify-between my-5 rounded-lg mx-auto p-5 shadow-lg bg-[#FFFFFF]">
//             {/* Address Selection */}
//             <div className="flex-1 mb-6 lg:mb-0 lg:mr-5">
//                 <h2 className="text-xl font-semibold mb-2">Address Details</h2>
//                 <p className="mb-4">Select from saved address</p>
//                 <div className='max-h-[500px] overflow-y-auto scrollbar-custom scroll-smooth p-2'>
//                     {loadingAddresses ? (
//                         <p className="text-gray-500">Loading addresses...</p>
//                     ) : (
//                         addresses?.map((address) => (
//                             <div
//                                 key={address._id}
//                                 className={`flex items-center bg-[#F8F8F8] p-4 mb-4 rounded-lg shadow-md cursor-pointer ${selectedAddress?._id === address._id ? 'border-2 border-blue-500' : ''}`}
//                                 onClick={() => handleSelect(address)}
//                             >
//                                 <div className="text-2xl mr-3"><MdOutlineLocationOn /></div>
//                                 <div>
//                                     <p className="font-bold">{address.zip}</p>
//                                     <p>{address.addressLine1}</p>
//                                     <p>{address.addressLine2}</p>
//                                 </div>
//                             </div>
//                         ))
//                     )}
//                 </div>

//                 <div className='flex gap-2 mt-4'>
//                     <button
//                         onClick={() => setIsOpen(!isOpen)}
//                         className="py-2 sm:px-4 px-2 bg-[#F1F9FF] text-[#14967F] text-sm sm:text-base rounded-[30px]"
//                     >
//                         + Add New Address
//                     </button>

//                     <ButtonWithLoader
//                         loading={loading}
//                         buttonText="Submit"
//                         onClick={setSelectedAddressFunc}
//                         width="w-[100px]"
//                     />
//                 </div>
//             </div>

//             {/* Attached Prescription */}
//             <div className='lg:w-2/5 lg:border-l-2'>
//                 <AttachedPrescription type="cart" stepperProgressCartData={stepperProgressCartData} />
//             </div>

//             {/* Address Popup */}
//             {isOpen && <Popup isOpen={isOpen} setIsOpen={setIsOpen} />}
//         </div>
//     );
// };

// export default AddressStep;
import React, { useEffect, useState, useCallback } from 'react';
import { MdOutlineLocationOn } from "react-icons/md";
import { apiGET, apiPUT } from '../../utilities/apiHelpers';
import { useSelector } from 'react-redux';
import Popup from '../Address/Popup';
import { toast } from 'react-toastify';
import AttachedPrescription from '../presecription/AttachedPrescription';
import scrollToTop from '../../utilities/scrollToTop';
import { API_URL } from '../../config';
import ButtonWithLoader from '../Button/ButtonWithLoader';

const AddressStep = ({ 
    stepperProgressCartData, 
    setStepperProgressCartData, 
    setCurrentStep // Ensure this prop is passed from the parent Stepper
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const userId = useSelector((state) => state.user?.userData?.id) || "";
    const [addresses, setAddresses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingAddresses, setLoadingAddresses] = useState(false);

    // Fetch user addresses
    const getUserAddresses = useCallback(async () => {
        if (!userId) return;
        try {
            setLoadingAddresses(true);
            const response = await apiGET(`/v1/address/getAddress/${userId}`);
            // Checking response.data.status for consistency with your API
            if (response?.data?.status) {
                const fetchedAddresses = response.data?.data || [];
                setAddresses(fetchedAddresses);
                
                // Optional: Auto-select default address if none is selected
                if (fetchedAddresses.length > 0 && !selectedAddress) {
                    const defaultAddr = fetchedAddresses.find(addr => addr.isDefault) || fetchedAddresses[0];
                    setSelectedAddress(defaultAddr);
                }
            } else {
                setAddresses([]);
            }
        } catch (error) {
            console.error("Error fetching addresses:", error);
            toast.error("Could not load addresses");
        } finally {
            setLoadingAddresses(false);
        }
    }, [userId, selectedAddress]);

    // Handle selecting an address
    const handleSelect = (address) => {
        setSelectedAddress(address);
    };

    // Submit selected address
    const setSelectedAddressFunc = async () => {
        if (!selectedAddress) {
            toast.error("Please select an address to proceed");
            return;
        }

        setLoading(true);
        // Payload matches your stepper progress requirements
        const payload = {
            selectedAddress,
            currentStep: 3 // Moving user to Step 3
        };

        try {
            const res = await apiPUT(`${API_URL}/v1/stepper-progress/update-stepper-progress/${userId}`, payload);
            
            // Check for success status in the response data
            if (res?.data?.status === true) {
                // Fetch fresh stepper data to keep global state in sync
                const stepperResponse = await apiGET(`${API_URL}/v1/stepper-progress/user-stepper-progress/${userId}`);
                
                if (typeof setStepperProgressCartData === "function") {
                    setStepperProgressCartData(stepperResponse.data?.data);
                }

                toast.success("Address confirmed");

                // MOVE TO NEXT STEP (Navigation)
                if (typeof setCurrentStep === "function") {
                    setCurrentStep();
                }
            } else {
                toast.error(res?.data?.message || "Failed to update address");
            }
        } catch (error) {
            console.error("Error updating selected address:", error);
            toast.error("Unable to save address selection");
        } finally {
            setLoading(false);
        }
    };

    // Load addresses when component mounts or popup closes
    useEffect(() => {
        scrollToTop();
        if (!isOpen) {
            getUserAddresses();
        }
    }, [isOpen, getUserAddresses]);

    return (
        <div className="flex flex-col lg:flex-row justify-between my-5 rounded-lg mx-auto p-5 shadow-lg bg-[#FFFFFF]">
            {/* Left Side: Address Selection */}
            <div className="flex-1 mb-6 lg:mb-0 lg:mr-5">
                <h2 className="text-xl font-semibold mb-2 text-gray-800">Address Details</h2>
                <p className="mb-4 text-gray-600">Please select a delivery address</p>
                
                <div className='max-h-[500px] overflow-y-auto scrollbar-custom scroll-smooth p-2'>
                    {loadingAddresses ? (
                        <div className="flex flex-col items-center py-10">
                            <div className="w-8 h-8 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mb-2"></div>
                            <p className="text-gray-500 text-sm">Loading saved addresses...</p>
                        </div>
                    ) : addresses.length > 0 ? (
                        addresses.map((address) => (
                            <div
                                key={address._id}
                                className={`flex items-start bg-[#F8F8F8] p-4 mb-4 rounded-xl shadow-sm border-2 transition-all cursor-pointer ${
                                    selectedAddress?._id === address._id 
                                    ? 'border-[#14967F] bg-teal-50' 
                                    : 'border-transparent hover:border-gray-200'
                                }`}
                                onClick={() => handleSelect(address)}
                            >
                                <div className={`text-2xl mr-3 ${selectedAddress?._id === address._id ? 'text-[#14967F]' : 'text-gray-400'}`}>
                                    <MdOutlineLocationOn />
                                </div>
                                <div className="flex-1">
                                    <p className="font-bold text-gray-800">{address.Name || "Delivery Address"}</p>
                                    <p className="text-sm text-gray-600 mt-1">{address.addressLine1}</p>
                                    <p className="text-sm text-gray-600">{address.addressLine2}</p>
                                    <p className="text-sm font-semibold text-gray-700 mt-1">{address.city}, {address.state} - {address.zip}</p>
                                </div>
                                {selectedAddress?._id === address._id && (
                                    <div className="bg-[#14967F] text-white rounded-full p-1">
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                    </div>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="py-10 text-center border-2 border-dashed border-gray-200 rounded-xl">
                            <p className="text-gray-500">No addresses saved yet.</p>
                        </div>
                    )}
                </div>

                <div className='flex items-center gap-4 mt-6'>
                    <button
                        onClick={() => setIsOpen(true)}
                        className="py-2 px-6 bg-[#F1F9FF] text-[#14967F] font-bold text-sm rounded-full hover:bg-teal-100 transition-colors"
                    >
                        + Add New Address
                    </button>

                    <ButtonWithLoader
                        loading={loading}
                        buttonText="Deliver Here"
                        onClick={setSelectedAddressFunc}
                        width="w-[140px]"
                    />
                </div>
            </div>

            {/* Right Side: Preview of items/prescription */}
            <div className='lg:w-2/5 lg:border-l lg:pl-5 border-gray-100'>
                <AttachedPrescription stepperProgressCartData={stepperProgressCartData} />
            </div>

            {/* Address Form Popup */}
            {isOpen && <Popup isOpen={isOpen} setIsOpen={setIsOpen} />}
        </div>
    );
};

export default AddressStep;
